import { Module } from 'vuex';
import { MasterState } from '@/store/master/types';
import { RootState } from '@/store/types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const Tutors: Module<MasterState, RootState> = {
  state,
  mutations,
  actions,
  getters,
};

export default Tutors;
